export default function HeroSection() {
  return (
    <section className="relative w-full h-screen overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Abstract%20atmospheric%20ambient%20forms%20resembling%20soft%20smoke%20and%20silk%20in%20desaturated%20cadet%20blue%20warm%20ivory%20and%20pale%20slate%20tones%20flowing%20organically%20across%20a%20dark%20canvas%20no%20human%20figures%20no%20products%20no%20identifiable%20objects%20purely%20abstract%20atmospheric%20composition%20with%20gentle%20gradients%20and%20ethereal%20movement&width=1920&height=1080&seq=hero-bg-tk-2026&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20" />

      <div className="absolute top-14 left-1/2 -translate-x-1/2 z-20 flex items-center justify-center h-[52px] w-[320px] border border-foreground-900 rounded-full">
        <span
          className="text-xs font-medium tracking-[0.2em] uppercase whitespace-nowrap"
          style={{ fontFamily: "var(--font-label)" }}
        >
          TK SOFTWARE FLOW LLC
        </span>
      </div>

      <div className="absolute top-0 left-0 w-full z-10 flex items-center h-[72px] px-12">
        <div className="flex items-center gap-10">
          <span className="text-[13px] font-light text-white/70 whitespace-nowrap" style={{ fontFamily: "var(--font-body)" }}>
            Clean Architecture
          </span>
          <span className="text-[13px] font-light text-white/70 whitespace-nowrap" style={{ fontFamily: "var(--font-body)" }}>
            Performance
          </span>
          <span className="text-[13px] font-light text-white/70 whitespace-nowrap" style={{ fontFamily: "var(--font-body)" }}>
            Scalability
          </span>
        </div>
        <div className="ml-auto">
          <div className="w-[6px] h-[6px] bg-white/50 rotate-45" />
        </div>
      </div>

      <div className="absolute z-10" style={{ left: "12%", top: "32%" }}>
        <h1
          className="uppercase text-white leading-[0.95]"
          style={{ fontFamily: "var(--font-heading)", fontWeight: 900 }}
        >
          <span className="block text-[5vw]">Modern Digital</span>
          <span className="block text-[7vw] ml-[10vw]">iOS Ecosystems</span>
          <span className="block text-[5vw]">Engineered to Last</span>
        </h1>
      </div>

      <div className="absolute z-10 flex" style={{ left: "12%", top: "68%" }}>
        <div className="w-[360px] text-[15px] font-normal text-white/85 leading-[1.7]" style={{ fontFamily: "var(--font-body)" }}>
          We design and develop modern digital software solutions for the iOS platform and related technologies. Every system we build is rooted in clean architecture, performance optimization, and user-centered design principles that ensure long-term maintainability and stability.
        </div>
        <div className="w-[360px] text-[15px] font-normal text-white/85 leading-[1.7] ml-[140px] -mt-[50px]" style={{ fontFamily: "var(--font-body)" }}>
          Our team follows modern software engineering practices with a strong emphasis on continuous innovation. We evolve our internal processes and adopt up-to-date engineering standards to deliver reliable, future-ready IT solutions that scale with confidence.
        </div>
      </div>
    </section>
  );
}